export const MAX_POST_PER_PAGE = 9;
